import { render } from "./ClientCompanyRecordsNav.vue?vue&type=template&id=50742ce6"
import script from "./ClientCompanyRecordsNav.vue?vue&type=script&lang=js"
export * from "./ClientCompanyRecordsNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__